import React, {useContext, useEffect, useState} from 'react';
import {RouteContext} from '../../../shared/enhancers/router-enhancer';
import {compose, Query} from 'react-apollo';
import {company} from '../../../data/company-profile/queries';
import {
  withAnalyticsPayload,
  withSendAnalyticsEvent
} from '../../../shared/enhancers/analytics-enhancer';
import {OrganizationContext} from '../../../shared/enhancers/organization-enhancer';
import {serializeUrl} from '../../company-dashboard/shared/utils';

export const OwnerContext = React.createContext(false);
// eslint-disable-next-line react/prop-types
const withCompanyProfile = Component => ({currentUser, ...restProps}) => {
  const {slug, signin} = useContext(RouteContext);
  const [searchText, setSearchText] = useState('');
  const {currentOrg} = useContext(OrganizationContext);

  useEffect(() => {
    serializeUrl();
  }, []);

  return (
    <Query query={company} variables={{id: slug, orgId: currentOrg && currentOrg.id}}>
      {({data, loading}) => {
        const company = data && data.company;
        const currentUserIsOwner =
          !loading && company && company.amIOwner && currentUser && !currentUser.loading;
        const context = {
          currentUserIsOwner,
          searchText,
          setSearchText
        };
        return (
          <OwnerContext.Provider value={context}>
            <Component
              {...restProps}
              company={company}
              loading={loading}
              signin={signin}
              analyticsPayload={{name: slug}}
            />
          </OwnerContext.Provider>
        );
      }}
    </Query>
  );
};

export default compose(
  withCompanyProfile,
  withAnalyticsPayload({
    'page.name': 'Company Profile',
    path: typeof window !== 'undefined' ? window.location.pathname : null,
    url: typeof window !== 'undefined' ? window.location.href : null,
    referrer: typeof document !== 'undefined' ? document.referrer : null
  }),
  withSendAnalyticsEvent
);
